/**
 * Fashion Moments Section - Connect external navigation buttons to slider
 */
(function() {
  'use strict';

  function initFashionMomentsSection(section) {
    const sliderComponent = section.querySelector('slider-component');
    const slider = section.querySelector('[id^="FashionMomentsSlider-"]');
    const sliderItems = section.querySelectorAll('[id^="FashionMomentsSlide-"]');
    const externalPrevButton = section.querySelector('.fashion-moments__control-button--prev');
    const externalNextButton = section.querySelector('.fashion-moments__control-button--next');

    if (!slider || !sliderItems.length || !externalPrevButton || !externalNextButton) return;

    let sliderItemOffset = 0;
    let slidesPerPage = 1;

    function initSlider() {
      const sliderItemsArray = Array.from(sliderItems).filter((item) => item.clientWidth > 0);
      if (sliderItemsArray.length < 2) {
        externalPrevButton.setAttribute('disabled', 'disabled');
        externalNextButton.setAttribute('disabled', 'disabled');
        return;
      }

      sliderItemOffset = sliderItemsArray[1].offsetLeft - sliderItemsArray[0].offsetLeft;
      slidesPerPage = Math.floor(
        (slider.clientWidth - sliderItemsArray[0].offsetLeft) / sliderItemOffset
      );

      updateButtonStates();
    }

    function updateButtonStates() {
      if (slider.scrollLeft <= 0) {
        externalPrevButton.setAttribute('disabled', 'disabled');
      } else {
        externalPrevButton.removeAttribute('disabled');
      }

      const maxScroll = slider.scrollWidth - slider.clientWidth;
      if (slider.scrollLeft >= maxScroll - 1) {
        externalNextButton.setAttribute('disabled', 'disabled');
      } else {
        externalNextButton.removeAttribute('disabled');
      }
    }

    // Connect external prev button
    externalPrevButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (!externalPrevButton.disabled && sliderItemOffset > 0) {
        slider.scrollTo({
          left: slider.scrollLeft - sliderItemOffset,
          behavior: 'smooth'
        });
      }
    });

    // Connect external next button
    externalNextButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (!externalNextButton.disabled && sliderItemOffset > 0) {
        slider.scrollTo({
          left: slider.scrollLeft + sliderItemOffset,
          behavior: 'smooth'
        });
      }
    });

    // Update button states on scroll
    slider.addEventListener('scroll', () => {
      updateButtonStates();
    });

    // Initialize on load and resize
    initSlider();
    const resizeObserver = new ResizeObserver(() => {
      initSlider();
    });
    resizeObserver.observe(slider);

    // Also observe the slider component if it exists
    if (sliderComponent) {
      sliderComponent.addEventListener('slideChanged', () => {
        updateButtonStates();
      });
    }
  }

  function initAllSections() {
    const sections = document.querySelectorAll('.fashion-moments-wrapper');
    sections.forEach((section) => {
      initFashionMomentsSection(section);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  // Re-initialize when new sections are added (for theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.detail.section;
      if (section && section.classList.contains('fashion-moments-wrapper')) {
        setTimeout(() => {
          initFashionMomentsSection(section);
        }, 100);
      }
    });
  }
})();
